"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var _default = (0, _react.createContext)();
exports.default = _default;